











































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class ReferFriendModal extends Vue {
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }
  mounted() {
    this.$modal.show('refer-friend-modal');
  }
  get referActionList() {
    return [
      {
        text: 'Refer a Friend for External Customer Projects',
        loggedInRoute: '/referafriend',
        loggedOutRoute: '/anonreferafriend',
      },
      {
        text: 'Refer a Friend for Internal Recruiting and Sales Positions',
        loggedInRoute: '/referinternalfriend',
        loggedOutRoute: '/anonreferinternalfriend',
      },
    ];
  }
}
